/* eslint-disable @typescript-eslint/no-var-requires */
declare let ENVIRONMENT: string

export namespace ConfigurationProvider {
    export interface Configuration {
        basePublicPath: string
    }
}

export class ConfigurationProvider {
    static getConfiguration(): ConfigurationProvider.Configuration {
        if (ENVIRONMENT === 'prod') {
            return require('./config.prod').default
        } else if (ENVIRONMENT === 'staging') {
            return require('./config.staging').default
        } else if (ENVIRONMENT === 'review') {
            return require('./config.review').default
        } else if (ENVIRONMENT === 'ci') {
            return require('./config.ci').default
        } else {
            return require('./config.dev').default
        }
    }
}
